/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpStatusIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import {
  InventoryPhysicalstock_summary_API,
  common_locaitonlist_API,
} from "../../Server/ApiV2";
import { useSelector } from "react-redux";
import {
  Set_SlicePhysicalStock_SummaryObj,
  Set_SlicePhysicalStock_HeadObj,
} from "./SlicePhysicalStock";

import { GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment";
import PhysicalStock_BreadCrumbs from "./PhysicalStock_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PhysicalStockSummaryTblCard } from "./processComponent/PhysicalStockSummaryTblCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import { Box } from "@mui/material";

export default function PhysicalStock() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [Summary_Grid_Columns, setSummary_Grid_Columns] = useState([
    {
      field: "A_SheetId",
      headerName: "Sheet No",
      width: 150,
    },
    {
      field: "LocName",
      headerName: "Location",
      width: 200,
    },
    {
      field: "A_RefNo",
      headerName: "RefNo",
      width: 100,
    },
    {
      field: "A_Date",
      headerName: "Date",
      width: 300,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "A_Status",
      headerName: "Status",
      width: 200,
    },
  ]);
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const [sSummaryLocation, setSummaryLocation] = useState([]);
  const [sSummaryObj, setSummaryObj] = useState({
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = (e) => {
    dispatch(
      Set_SlicePhysicalStock_SummaryObj({
        sSummaryObj,
      })
    );
    Get_Load_Grid_Data(
      sSummaryObj.loc,
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      vRdxuserInfo.UserID
    );
    setShowModal(false);
  };
  const Get_Load_Grid_Data = useCallback(
    async (xLoc, xDate1, xDate2, xUserCd) => {
      var vSummaryObj = {
        loc: xLoc,
        date1: moment(xDate1).format("MM/DD/YYYY"),
        date2: moment(xDate2).format("MM/DD/YYYY"),
        usercd: xUserCd,
      };
      const vItemSearch = await InventoryPhysicalstock_summary_API(vSummaryObj);

      if (vItemSearch?.status === 200) {
        if (vItemSearch?.data?.ResultSet?.length > 0) {
          const itemRows = vItemSearch?.data?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
            // A_Date: moment(obj.A_Date).format("DD/MM/YYYY"),
          }));
          setSummaryGridRow(itemRows);
        } else {
          setSummaryGridRow([]);
        }
      }
    },
    []
  );

  const fRowCLick = (item) => {
    dispatch(
      Set_SlicePhysicalStock_HeadObj({
        SheetNo: item?.A_SheetId,
        Loc: item?.A_Loc,
        LocName: item?.LocName,
        Date: item?.A_Date,
        ReferenceNo: item?.A_RefNo,
        A_DocStat: item?.A_Status,
      })
    );
    navigate("/PhysicalStockDetail");
  };
  const fNew = () => {
    dispatch(
      Set_SlicePhysicalStock_HeadObj({
        SheetNo: 0,
        Loc: sSummaryLocation[0]?.UId,
        LocName: "",
        Date: new Date(),
        ReferenceNo: "",
        A_DocStat: "ENTER",
      })
    );
    setShowModal(false);
    navigate("/PhysicalStockDetail");
  };

  const getLocation = useCallback(async () => {
    let locationObj = {
      usercd: vRdxuserInfo.UserID,
    };
    let locationList = await common_locaitonlist_API(locationObj);
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setSummaryLocation(locationList?.data?.ResultSet);
        setSummaryObj((obj) => ({
          ...obj,
          loc: locationList.data?.ResultSet[0]?.UId,
        }));
      }
    }
  }, [vRdxuserInfo.UserID]);

  useEffect(() => {
    getLocation();
  }, [getLocation]);

  useEffect(() => {
    Get_Load_Grid_Data(
      sSummaryObj.loc,
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      vRdxuserInfo.UserID
    );
  }, [
    sSummaryObj.loc,
    sSummaryObj.dateFrom,
    sSummaryObj.dateTo,
    vRdxuserInfo.UserID,
    Get_Load_Grid_Data,
  ]);

  useEffect(() => {
    LocationFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
    GetGitterColumns(
      setSummary_Grid_Columns,
      "PHYSICAL_STOCK_SUMMARY",
      Summary_Grid_Columns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <PhysicalStock_BreadCrumbs />
        <Box sx={{ display: "flex", gap: 1 }}>
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
          <CmpButton
            xbtnName="New"
            xOnClick={fNew}
            xVariant="contained"
            xSize="small"
          />
        </Box>
      </div>
      <div style={{ margin: "auto", width: "100%" }}>
        {/* <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center"
          style={{display: 'none'}}
        >
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={sSummaryObj.loc}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={sSummaryLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sSummaryObj.dateFrom}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={12} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sSummaryObj.dateTo}
              xOnChange={(newValue) =>
                setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>

          <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>

          <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid> */}
        <>
          {/* <Box
            sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}
            className="bin-transfer-data"
          > */}
          {/* <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sSummaryGridRow}
              columns={Summary_Grid_Columns}
              hideFooter={sSummaryGridRow.length < 100}
              onRowClick={fRowCLick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            /> */}

          {/* <PhysicalStockSummaryTblCard data={sSummaryGridRow} onClick={fRowCLick} /> */}
          <div
            style={{
              height: vMediaQuery ? "65vh" : "85vh",
              overflowY: "auto",
              marginTop: "4px",
              padding: vMediaQuery ? "0px" : "10px",
            }}
          >
            <Grid container spacing={1}>
              {Array.isArray(sSummaryGridRow) &&
                sSummaryGridRow?.length > 0 &&
                sSummaryGridRow?.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={(item) => fRowCLick(item)}
                      headerLabel={item?.LocName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label="Sheet No"
                            value={item?.A_SheetId}
                          />
                          <DetailInputDisplay
                            label="Voc Date"
                            value={moment(item?.A_Date).format("DD/MM/YYYY")}
                          />
                          <DetailInputDisplay
                            label="Ref No"
                            value={item?.A_RefNo}
                          />
                          <DetailInputDisplay
                            label="Doc.Status"
                            value={<CmpStatusIcon xStatus={item?.A_Status} />}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={3.5} className="align-items-center">
              <Grid item xs={12}>
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={sSummaryLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                  xFullWidth={"100%"}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                  xFullWidth={"100%"}
                />
              </Grid>

              <Grid
                item
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
